import { Immutable } from "immer";

import { Button } from "@/components/ui/button";
import { FormItem } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { LatestContentBlock } from "@/gen/realtime";

import { FormControl, FormLabel } from "./shared";

const filters = [
    { key: "onlyWithVideo", title: "Only show videos" },
    { key: "onlyStories", title: "Only show stories" },
    { key: "all", title: "All published content" },
] as const;

export const LatestContentForm = ({
    block,
    setBlock,
}: {
    block: Immutable<LatestContentBlock>;
    setBlock: (mutate: (block: LatestContentBlock) => void) => void;
}) => {
    return (
        <div className="flex-grow space-y-6">
            <div className="text-md font-bold">Filter</div>
            <div className="flex flex-row gap-4">
                {filters.map(filter => (
                    <Button
                        key={filter.key}
                        onClick={() => {
                            setBlock(block => {
                                block.filter = { t: filter.key };
                            });
                        }}
                        variant={block.filter.t === filter.key ? "default" : "outline"}
                    >
                        {filter.title}
                    </Button>
                ))}
            </div>

            <FormItem>
                <FormLabel className="text-md font-bold">Title</FormLabel>
                <FormControl>
                    <Input
                        placeholder="Teaser title"
                        value={block.title}
                        onChange={e =>
                            setBlock(block => {
                                block.title = e.target.value;
                            })
                        }
                    />
                </FormControl>
            </FormItem>
            <FormItem>
                <FormLabel className="text-md font-bold">Subtitle</FormLabel>
                <FormControl>
                    <Input
                        placeholder="Lead text"
                        value={block.subtitle ?? ""}
                        onChange={e =>
                            setBlock(block => {
                                block.subtitle = e.target.value;
                            })
                        }
                    />
                </FormControl>
            </FormItem>
            <FormItem>
                <FormLabel className="text-md font-bold">How many items</FormLabel>
                <FormControl>
                    <Input
                        placeholder="3"
                        defaultValue={block.num.toString() ?? ""}
                        onChange={e =>
                            setBlock(block => {
                                const parsed = parseInt(e.target.value);
                                if (parsed > 0) {
                                    block.num = parsed;
                                }
                            })
                        }
                    />
                </FormControl>
            </FormItem>
        </div>
    );
};
